<!--发表记录  -->
<template>
<div class="wx-mater-drafts">
	<!-- 标题 -->
	<div class="page-title">发表记录</div>
	
	<div style="margin-top: 20px;display: flex;">
		<div style="width: 222px;">
			<div style="position: sticky;top: 80px;">
				<!-- <div style="font-size: 16px;font-weight: 600;margin-bottom: 10px;cursor: default;">书城列表</div> -->
				<div style="margin-bottom: 10px;">
					<!-- <a-input placeholder="搜索公众号" /> -->
					<a-input-search placeholder="搜索公众号" enter-button @search="onSearchGzh" />
				</div>
				<div style="border-right: 1px solid #e8e8e8;height: 100%;overflow-y: overlay;" :style="{'height': left_book_height + 'px'}">
					<!-- <div v-for="(item,index) in bookList" :key="index" class="left-label" 
					:style="{'background-color': item.status?'aliceblue':''}"
					@click="changeBook(item,index)">
						<div style="flex: 1;padding-left: 15px;">
						{{item.label}} 	
						</div>
						<div v-if="item.status" style="width: 3px;height: 100%;background-color: #409eff;"></div>
					</div> -->
					<a-menu
					      style="width: 200px"
					      :default-selected-keys="['1']"
					      :open-keys.sync="openKeys"
					      mode="inline"
					      @click="handleClickGzh"
					    >
					    <a-sub-menu v-for="(value,key) in menuData" :key="key" @titleClick="titleClick($event,value)">
					        <span slot="title"><span style="text-align: left;">{{key}}</span></span>
					        <a-menu-item v-for="(item,index) in value" :key="item.id" >
					          {{item.gzh_name}}
					        </a-menu-item>
					    </a-sub-menu>
					</a-menu>
				</div>
			</div>
		</div>
		
		<div style="flex: 1;padding-left: 25px;">
			<div>
				<div>
					<div v-for="(item,index) in itemData" :key="index" class="item-box">
						<div class="item-box-title">发布时间：{{item.created_at}}</div>
						<div style="position: relative;">
							<img class="item-top-img" style="" :src="item.content[0].local_thumb_url" alt="">
							<div class="item-top-title" style="">{{item.content[0].title}}</div>
						</div>
						<div v-for="(item_z,index_z) in item.content" :key="index_z">
							<div v-if="index_z > 0" class="item-cell-box">
								<div style="flex: 1;">{{item_z.title}}</div>
								<img class="item-cell-img" :src="item_z.local_thumb_url" alt="">
							</div>
							
						</div>
						
						<!-- <div class="item-button-box" style=""> -->
							<!-- <a-button @click="handleButton(3,item)" type="danger" size='small' style="margin-right: 10px;">删除</a-button> -->
						<!-- </div> -->
					</div>
				</div>
				
				<div v-show="itemData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;">
					<a-icon style="font-size: 70px;color: #999;" type="file-search" />
					<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
				</div>
				
				<!-- 分页 -->
				<div style="clear: both;"></div>
				<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;">
					<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" show-quick-jumper />
				</div>
			</div>
			
		</div>
	</div>
	
	<a-modal
	      title="群发消息"
	      :visible="message_visible"
	      :confirm-loading="message_confirmLoading"
	      @ok="messageHandleOk"
	      @cancel="messageHandleCancel"
		  width="600px"
	    >
		<div>
			<div class="form-cell-box">
				<div class="class-title">群发类型</div>
				<div>
					<a-radio-group @change="messTypeA" name="radioGroup" :value="s_send_time_type">
						<a-radio :value="2">
						  定时群发
						</a-radio>
						<a-radio :value="1">
						  立刻群发
						</a-radio>
					</a-radio-group>
				</div>
			</div>
		    
			<div v-if="s_send_time_type == 2" class="form-cell-box">
				<div class="class-title">发送时间</div>
					
				<a-date-picker show-time
				 style="width:340px" @change="onSendChange" 
				 :allowClear="false" placeholder="选择发送时间" 
				  :disabledDate="disabledDate"/>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">人群</div>
				<div>
					<a-radio-group @change="messTypeB" name="radioGroup" :value="s_send_type">
						<a-radio :value="1">
						  全部用户
						</a-radio>
						<a-radio :value="2">
						  按标签选择
						</a-radio>
					</a-radio-group>
				</div>
			</div>
			
			<div v-if="s_send_type == 2" class="form-cell-box">
				<div class="class-title">标签</div>
					
				<a-select 
				 style="width: 340px" 
				 placeholder="未选择"
				 :filter-option="filterOption"
				 @change="handleChangeH" 
				 showSearch 
				>
					<a-select-option v-for="(item,index) in sendTagData" :key="index" :value="item.tag_id">
						{{item.tag_name}}
					</a-select-option>
				</a-select>
			</div>
		</div>
	</a-modal>
	
	<a-modal
	      title="预览"
	      :visible="preview_visible"
	      :confirm-loading="preview_confirmLoading"
	      @ok="previewOk"
	      @cancel="previewCancel"
		  width="600px"
	    >
		<div>
			<div class="form-cell-box">
				<div class="class-title">微信号</div>
				<a-input v-model="s_wechat_id" placeholder="请输入微信号" style="width: 330px;"/>
			</div>
		    
		</div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { wxMaterialDraft, wxMaterialPreview, wxMaterialDel, materialList, materialChannelSelect, wxMaterialAllSelect, wxMaterialSend, wxMaterialTag, wxMaterialDraftSync } from '@/request/api'
export default {
	name: 'publishRecord_', //已废弃。这个页面的内容已经移到/wxMaterialDrafts页面了
	components: {
		
	},
	data() {
		return {
			locale,
			moment,
			x_put_date:"", // 日期选择
			
			bookList: [],
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 20, // 每页多少条
			table_total: 0, // 总数
			
			itemData: [],
			
			r_name: null,
			r_channel_id: null, // 渠道/书城
			
			selectData: {}, // 下拉
			
			left_book_height: 300, // 左边书城列表的高度
			
			// 群发消息弹窗
			message_visible: false, 
			message_confirmLoading: false,
			
			
			current: ['mail'],
			openKeys: ['sub1'],
			
			sync_true: false, // 刷新的icon是否旋转
			sync_true_control: true, // 刷新的节流控制
			
			menuData: [], // 左侧渠道数据
			
			r_gzh_id: null, // 公众号id
			
			s_id: null, // 列表ID，用于群发消息
			s_send_type: 2, // 发送类型：1=全部，2=按标签id
			s_send_time_type: 2, // 发送时间类型，1=立即发送，2=定时发送
			s_tag_id: undefined, // send_type=2 必传标签id
			s_send_time: undefined, // send_time_type=2必传时间
			sendTagData: [], // 标签
			
			// 预览弹窗
			preview_visible: false, 
			preview_confirmLoading: false, 
			s_wechat_id: "", // 微信号
		}
	},
	mounted() {
		let that = this
		
		console.log("document.body.clientHeight",document.body.clientHeight);
		
		that.left_book_height = document.body.clientHeight - 65 - 20 - 36 -20 - 24 - 10 - 20 - 10
		console.log("that.left_book_height",that.left_book_height);
		
		
		
		// 获取 左侧渠道>公众号
		that.onSearchGzh(null)
		
		
		// materialChannelSelect().then(res=>{
		// 	console.log("下拉",res);
		// 	that.selectData = res.data.data
		// 	let c_data = res.data.data.channel
		// 	let show_data = []
		// 	for (let key in c_data) {
		// 		let ooo = {
		// 			key,
		// 			label: c_data[key],
		// 			status: false,
		// 		}
		// 		show_data.push(ooo)
		// 	}
		// 	// show_data[0].status = true
		// 	that.bookList = show_data
		// 	console.log("show_data",show_data);
		// })
		
		
		
		// that.searchButton()
	},
	watch: {
	    openKeys(val) {
	      console.log('openKeys', val);
	    },
	},
	methods: {
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeH(e){
			this.s_tag_id = e
		},
		onSearchGzh(e){
			console.log("公众号搜索",e);
			let that = this
			that.search_button_loading = true
			wxMaterialAllSelect({ // 获取左侧下拉
				gzh_name: e
			}).then(res=>{
				console.log("获取所有下拉",res.data.data.list);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.menuData = res.data.data.list
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 点击公众号
		handleClickGzh(e) {
		    console.log('click', e);
			let that = this
			this.search_button_loading = true
			this.r_gzh_id = e.key
			
			this.searchButton()
			// wxMaterialTag({
			// 	gzh_id: this.r_gzh_id
			// }).then(res=>{
			// 	console.log("获取标签",res);
			// 	that.sendTagData = res.data.data.data
			// })
		},
		titleClick(e,value) {
			let that = this
			
		},
	    searchButton(type){
			let that = this
			that.search_button_loading = true
			let r_data = {
				page: that.r_page, // 页数
				limit: that.r_limit, // 每页多少条
				gzh_id: that.r_gzh_id, // 公众号ID
				is_send: 1, // 表示已发布的草稿箱列表
			}
			wxMaterialDraft(r_data).then(res=>{
				console.log("获取列表",res.data.data);
				that.search_button_loading = false
				if(type == 'refresh'){
					that.sync_true = false
					that.r_page = 1
				}
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					if(type == 'button'){
						that.r_page = 1
					}
					that.itemData = res.data.data.data
					that.table_total = res.data.data.total
					
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 刷新
		RefreshButton(){
			this.sync_true = true
			this.searchButton('refresh')
		},
		goAdd(){
			this.$router.push({ path:'/materialAdd'})
		},
		// 切换书城列表
		changeBook(e,index){
			console.log("切换书城列表",e);
			this.bookList.forEach(res=>{
				res.status = false
			})
			this.bookList[index].status = true
			this.r_channel_id = e.key
			this.searchButton()
		},
		paginationChange(e){
			this.r_page = e
			this.searchButton()
		},
		
		// 操作按钮
		handleButton(e,item){
			console.log(item);
			let that = this
			if(e == 1){ // 编辑
				
			}
			else if(e == 2){ // 预览
				this.s_id = item.id
				this.preview_visible = true
			}
			else if(e == 3){ // 删除
				this.$confirm({
					title: '确定要删除吗?',
					content: `id：${item.id}`,
					okText: '删除',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
					  wxMaterialDel({
						  id: item.id
					  }).then(res=>{
						console.log("删除",res);
						if(res.data.code == 0){
							that.$message.success('删除成功');
							that.searchButton()
						}
						else {
							if(res.data.code === 401){ // 未登录
							  	localStorage.removeItem("access_token");
							  	that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
							  	that.$message.error(`错误：${res.data.msg}`);
							}
						}
					  })
					},
					onCancel() {
					  console.log('Cancel');
					},
				});
			}
			else if(e == 4){ // 群发
				this.s_id = item.id
				this.message_visible = true
			}
			
		},
		
		
		// 群发消息弹窗
		messageHandleOk(){
			let that = this
			if(that.s_send_time_type == 2 && !that.x_put_date){
				this.$message.warning('请选择发送时间')
			}
			else if(that.s_send_type == 2 && !that.s_tag_id){
				this.$message.warning('请选择标签')
			}
			else {
				this.message_confirmLoading = true
				wxMaterialSend({
					id: that.s_id, // 列表id
					send_type: that.s_send_type, // 发送类型：1=全部，2=按标签id
					send_time_type: that.s_send_time_type,
					tag_id: that.s_tag_id,
					send_time: that.s_send_time,
				}).then(res=>{
					that.message_confirmLoading = false
					console.log("群发消息弹窗-确认",res);
					
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success(res.data.msg)
						that.messageHandleCancel()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			
			
		},
		messageHandleCancel(){
			this.s_tag_id = undefined
			this.s_send_time = undefined
			
			this.message_visible = false
		},
		// 切换群发类型
		messTypeA(e){
			console.log("切换群发类型",e);
			this.s_send_time_type = e.target.value
		},
		// 切换人群
		messTypeB(e){
			console.log("切换人群",e);
			this.s_send_type = e.target.value
		},
		// 发送时间
		onSendChange(date, dateString){
			console.log(date, dateString);
			this.x_put_date = dateString
		},
		disabledDate (current) {
			// 今天之前的日期不可选，不包括今天。也就是今天也可以选，今天以及今天以后的日期都可以选
			return current && current < moment().subtract(1,"days")
		},
		
		// 手动微信同步草稿箱
		syncWxDraft(){
			let that = this
			if(!this.r_gzh_id){
				this.$message.warning('请先选择公众号')
			}
			else {
				this.search_button_loading = true
				wxMaterialDraftSync({
					id: this.r_gzh_id
				}).then(res=>{
					that.search_button_loading = false
					console.log("手动微信同步草稿箱",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success(res.data.msg)
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			
		},
		
		// 预览弹窗
		previewOk(){
			let that = this
			that.preview_confirmLoading = true
			wxMaterialPreview({
				id: this.s_id,
				wechat_id: this.s_wechat_id
			}).then(res=>{
				console.log("预览弹窗",res);
				that.preview_confirmLoading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success(res.data.msg)
					that.previewCancel()
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		previewCancel(){
			this.s_wechat_id = ""
			this.preview_visible = false
			
		},
	},
}
</script>

<style scoped>
.wx-mater-drafts {
	
}
.left-label {
	display: flex;
	justify-content: space-between;
	height: 36px;
	line-height: 36px;
	cursor: pointer;
}
.left-label:hover {
	background-color: aliceblue;
}

.item-box {
	width: 300px;
	padding: 25px;
	/* border: 1px solid #ccc; */
	display: inline-block;
	margin: 0 50px 30px 0;
	border-radius: 12px;
	vertical-align: top;
	background-color: #fff;
}
.item-box-title {
	font-size: 14px;
	margin-bottom: 18px;
}
.item-top-img {
	width: 100%;
	height: 150px;
}
.item-top-title {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	background-color: rgba(0,0,0,0.7);
	color: #fff;
	padding: 5px;
}
.item-cell-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #e8e8e8;
	padding: 10px 0;
}
.item-cell-img {
	width: 70px;
	height: 70px;
}
.item-button-box {
	display: flex;
	flex-wrap: wrap;
	margin-top: 15px;
}

::-webkit-scrollbar{display:none}
</style>